<template>
  <v-btn
    v-if="showBackToSetup"
    variant="text"
    size="small"
    prepend-icon="mdi-arrow-left"
    :to="to"
    class="back-to-setup-link text-none px-0"
  >
    {{ label }}
  </v-btn>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useProductSettingsStore } from '@/stores/productSettings'

const productSettings = useProductSettingsStore()

withDefaults(
  defineProps<{
    to?: string
    label?: string
  }>(),
  {
    to: '/setup',
    label: 'Back to Setup',
  },
)

/** Hide during onboarding — config pages are part of the flow, not the Setup hub. */
const showBackToSetup = computed(() => !productSettings.isOnBoarding)
</script>
